import { render } from "./specialcolumn.vue?vue&type=template&id=4101d116&scoped=true"
import script from "./specialcolumn.vue?vue&type=script&lang=js"
export * from "./specialcolumn.vue?vue&type=script&lang=js"

import "./specialcolumn.vue?vue&type=style&index=0&id=4101d116&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4101d116"

export default script